export const MENUITEMS_DEFAULT = [
  {
    label: 'procedure',
    icon: 'pi pi-fw pi-star',
    items: [
      { label: 'planned', icon: 'pi pi-fw pi-calendar', routerLink: ['/acs/planned'], right: 'admin.ac.list' },
      { label: 'running', icon: 'pi pi-fw pi-clock', routerLink: ['/acs/running'], right: 'admin.ac.list' },
      { label: 'finished', icon: 'pi pi-fw pi-check-square', routerLink: ['/acs/finished'], right: 'admin.ac.list' },
      { label: 'cancelled', icon: 'pi pi-fw pi-ban', routerLink: ['/acs/cancelled'], right: 'admin.ac.list' },
    ],
  },
  {
    label: 'reportings',
    icon: 'pi pi-fw pi-chart-bar',
    items: [
      { label: 'orderplanning', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/orderplanning'], right: 'admin.reportings.orderplanning' },
      { label: 'acroles', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/acroles'], right: 'admin.reportings.acroles' },
      { label: 'rolestatistics', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/rolestatistics'], right: 'admin.reportings.rolestatistics' },
      { label: 'observerlist', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/reportings/observerlist'], right: 'admin.reportings.observerlist' },
    ],
  },
  {
    label: 'basedata',
    icon: 'pi pi-fw pi-star',
    items: [
      { label: 'templates', icon: 'pi pi-fw pi-clone', routerLink: ['/templates'], right: 'admin.template.list' },
      { label: 'exercises', icon: 'pi pi-fw pi-briefcase', routerLink: ['/exercises'], right: 'admin.exercise.list' },
      { label: 'competences', icon: 'pi pi-fw pi-palette', routerLink: ['/competences'], right: 'admin.competence.list' },
      { label: 'ratingtypes', icon: 'pi pi-fw pi-thumbs-up', routerLink: ['/ratingtypes'], right: 'admin.ratingtype.list' },
      { label: 'recommendations', icon: 'pi pi-fw pi-compass', routerLink: ['/recommendations'], right: 'admin.recommendation.list' },
      { label: 'customers', icon: 'pi pi-fw pi-id-card', routerLink: ['/customers'], feature: 'customers', right: 'admin.customer.list' },
    ],
  },
  {
    label: 'statistics',
    icon: 'pi pi-fw pi-chart-bar',
    items: [{ label: 'competences', icon: 'pi pi-fw pi-palette', routerLink: ['/statistics/acs/competences'], right: 'admin.statistics.competences' }],
  },
  {
    label: 'contents',
    icon: 'pi pi-fw pi-star',
    items: [
      { label: 'texttemplates', icon: 'pi pi-fw pi-align-left', routerLink: ['/contents/texttemplates'], right: 'admin.texttemplate.list' },
      { label: 'textblocks', icon: 'pi pi-fw pi-list', routerLink: ['/contents/textblocks'], right: 'admin.textblock.list' },
      { label: 'documents', icon: 'pi pi-fw pi-copy', routerLink: ['/contents/documents'], right: 'admin.document.list' },
    ],
  },
  {
    label: 'administration',
    icon: 'pi pi-fw pi-star',
    items: [
      { label: 'users', icon: 'pi pi-fw pi-user', routerLink: ['/users'], right: 'admin.user.list' },
      { label: 'rights', icon: 'pi pi-fw pi-key', routerLink: ['/rights'], right: 'admin.role.list' },
      { label: 'billing', icon: 'pi pi-fw pi-money-bill', routerLink: ['/billing'], feature: 'billing', right: 'admin.billing.list' },
    ],
  },
  {
      label: 'onlinetests',
      icon: 'pi pi-fw pi-star',
      items: [{ label: 'partners', icon: 'pi pi-fw pi-shield', routerLink: ['/partners'], right: 'admin.partner.list' }],
  },
];
